export default __webpack_public_path__ + "static/media/img_post4_1.ed511b2c.png";